export default {
  base: {
    // TODO add color definition to theme - blueberry
    color: 'text',
    title: {
      variant: 'styles.h6',
      lineHeight: '24px',
      // TODO H6 is only bold?
      fontWeight: 'xxbold',
      fontSize: '20px',
      m: '0'
    }
  },
  variants: {
    info: {
      backgroundColor: 'grey-0',
      borderColor: 'grey-20'
    },
    error: {
      bg: 'error_bg',
      borderColor: 'error_border'
    },
    warning: {
      bg: 'warning_bg',
      borderColor: 'warning_border'
    },
    success: {
      bg: 'success_bg',
      borderColor: 'success_border'
    },
    primary: {
      variant: 'spark.element.alert.base',
      bg: 'info_bg',
      borderColor: 'info_border',
      title: {
        variant: 'spark.element.alert.base.title'
      },
      header: {
        variant: 'spark.element.alert.base.header'
      },
      close: {
        variant: 'spark.element.alert.base.close'
      }
    }
  }
};